import { render, staticRenderFns } from "./CustomerRouteCustomersModal.vue?vue&type=template&id=8c2f0bea&scoped=true&"
import script from "./CustomerRouteCustomersModal.vue?vue&type=script&lang=js&"
export * from "./CustomerRouteCustomersModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRouteCustomersModal.vue?vue&type=style&index=0&id=8c2f0bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2f0bea",
  null
  
)

export default component.exports